import AdminEditWarning from 'components/Admin/AdminEditWarning/AdminEditWarning';
import ComingSoonSetting from 'components/Admin/StatusSettings/ComingSoonSetting';
import { DescriptionInputs } from 'components/Admin/DescriptionInputs/DescriptionInputs';
import JSONPreview from 'components/Admin/JSONPreview/JSONPreview';
import LanguageSettings from 'components/Admin/LanguageSettings/LanguageSettings';
import LearningMaterialsTable from 'components/Admin/LearningMaterialsTable/LearningMaterialsTable';
import TitleInputs from 'components/Admin/TitleInputs/TitleInputs';
import VisibleSetting from 'components/Admin/StatusSettings/VisibleSetting';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useStores } from 'index';

export const EditStudyLesson = observer(() => {
  useSetPageTitle({ title: 'Edit study lesson', subtitle: '' });
  const { studyLessonId } = useParams();
  const sll = useStores().studyroomLessonEditorStore;

  useEffect(() => {
    if (studyLessonId) {
      sll.getLesson(studyLessonId);
    }
    return () => {
      sll.studyLesson = { ...sll.cleanStudyLesson };
    };
  }, [sll, studyLessonId]);

  const handleSaveLesson = () => {
    if (studyLessonId) {
      sll.saveEditedLessonAndUpdate();
    } else {
      sll.saveNewLessonAndUpdate();
    }
  };

  return (
    <>
      <div className='admin-content-container'>
        <AdminEditWarning />
        <LanguageSettings dataItem={sll.studyLesson} />
        <TitleInputs titles={sll.studyLesson.titles} languages={sll.studyLesson.languages} />
        <DescriptionInputs dataItem={sll.studyLesson} />
        <div className='admin-edit-section'>
          <h2>Settings</h2>
          <div className='checkboxes-container'>
            <VisibleSetting dataItem={sll.studyLesson} />
            <ComingSoonSetting dataItem={sll.studyLesson} />
          </div>
        </div>
        <LearningMaterialsTable />
        <JSONPreview jsonPreview={JSON.stringify(sll.studyLesson, null, 2)} />
        <div className='admin-footer'>
          <button
            className='styled-button primary'
            onClick={() => handleSaveLesson()}
            disabled={sll.studyLesson.titles.find((title) => title.countryCode === 'en-US')?.text === ''}
          >
            Save changes
          </button>
        </div>
      </div>
    </>
  );
});

export default EditStudyLesson;
